<template>
    <div style="display: flex;">
        <el-card class="box-card" style="min-width: 400px;width: 32.75rem;">
            <el-carousel :interval="4000" type="card" height="250px">
                <el-carousel-item v-for="(item, index) in (list.img_url ? [list.img_url] : [])" :key="index">
                    <el-image
                        style="width: 100%;"
                        :src="item">
                    </el-image>
                </el-carousel-item>
            </el-carousel>
            <div style="width: 100%;">
                <!-- <h4 class="title_h4">Bullet points</h4> -->
                <h4 class="title_h4">要点</h4>
                <div class="content_div">
                    <div style="position: relative; overflow: hidden; display: inline-block; margin: 0px; width: 100%; height: 170px;width: 100%!important;">
                        <div style="overflow: hidden; position: relative; display: block;width: 100%;height: 10.625rem;overflow: scroll;">
                            <ul style="width: 98%;font-size: 13px;">
                                <li class="ng-star-inserted"  v-for="(item, index) in list.features" :key="index">
                                    {{item}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card class="box-card" style="min-width: 700px;width: calc(100% - 34rem);margin-left: 1.25rem;">
            <div class="info-title">
                <div class="name" style="width: 100%">
                    <ul style="display: flex;">
                        <li>
                            <span>ASIN：</span>
                            <span style="font-weight: 400;">{{list.asin}}</span>
                            <!-- <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer;" title="复制"></i> -->
                        </li>
                        <li>
                            <span>国家：</span>
                            <span style="font-weight: 400;">{{list.state}}</span>
                            <!-- <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer;" title="复制"></i> -->
                        </li>
                        <!-- <li>
                            <span>PASIN：</span>
                            <span style="font-weight: 400;">{{list.parent_asin}}</span>
                        </li> -->
                        <!-- <li>
                            <span>是否变狗：</span>
                            <span style="font-weight: 400;">{{is_dog}}</span>
                            <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer;" title="复制"></i>
                        </li> -->
                        <!-- <li style="flex: 1;margin-right: 10px;text-align: right">
                            <i class="el-icon-download" style="margin-left: 5px;font-size: 18px;color: red;cursor: pointer;" title="下载"></i>
                            <i class="el-icon-paperclip" style="margin-left: 5px;font-size: 18px;color: red;cursor: pointer;" title="跳转链接"></i>
                        </li> -->
                    </ul>
                    <div class="des">
                        <span class="des-title">
                            <span>
                                标题：
                            </span>
                            {{list.title}}
                        </span>
                        <!-- <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer;" title="复制"></i> -->
                    </div>
                </div>
            </div>
            <div class="all-type">
                <div class="left-ul">
                    <el-form label-width="50%">
                        <el-form-item label="父asin：">
                            <span>{{list.parent_asin}}</span>
                        </el-form-item>
                        <el-form-item label="品牌：">
                            <span>{{list.brand}}</span>
                        </el-form-item>
                        <el-form-item label="类目：">
                            <el-popover placement="top" title trigger="hover">
                                <div style="width: 300px;">
                                    <span>{{list.category_tree}}</span>
                                </div>
                                <div class="grade_num" slot="reference">{{list.category_tree}}</div>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="评分数/评论数：">
                            <span>{{list.rating}} / {{list.rating_count}}</span>
                        </el-form-item>
                        <!-- <el-form-item label="好评率：">
                            <span>79%</span>
                        </el-form-item>
                        <el-form-item label="差评率：">
                            <span>12%</span>
                        </el-form-item> -->
                        <el-form-item label="评分/星级：">
                            <div style="display: flex;align-items: center;">
                                <span style="margin-right: 5px;">{{list.rating}}</span>
                                <el-rate
                                    :value="Number(list.rating)"
                                    disabled
                                    score-template="{value}"
                                ></el-rate>
                            </div>
                        </el-form-item>
<!--                        <el-form-item label="问答数：">-->
<!--                            <span>{{list.qa_num}}</span>-->
<!--                        </el-form-item>-->
                        <el-form-item label="价格：">
                            <span>{{list.price}}</span>
                        </el-form-item>
<!--                        <el-form-item label="热销榜单：">-->
<!--                            <el-popover placement="top" title trigger="hover">-->
<!--                                <div style="width: 300px;">-->
<!--                                    <div v-for="(tiem, i) in list.best_sellers_rank" :key="i">{{`${i}： ${tiem}；`}}</div>-->
<!--                                </div>-->
<!--                                <div class="grade_num" slot="reference">-->
<!--                                    <span v-for="(tiem, i) in list.best_sellers_rank" :key="i">{{`${i}： ${tiem}；`}}</span>-->
<!--                                </div>-->
<!--                            </el-popover>-->
<!--                        </el-form-item>-->
                        <!-- <el-form-item label="BuyBox价格：">
                            <span>$14.99</span>
                        </el-form-item>
                        <el-form-item label="Buybox卖家：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="Buybox配送：">
                            <span>无</span>
                        </el-form-item>
                        <el-form-item label="Buybox卖家所属地：">
                            <span>--</span>
                        </el-form-item> -->
                    </el-form>
                </div>
                <div style="width: 50%">
                    <el-form label-width="50%">
                        <el-form-item label="是否变狗：">
                            <span>{{is_dog}}</span>
                        </el-form-item>
<!--                        <el-form-item label="卖家：">-->
<!--                            <span>{{list.buybox_seller}}</span>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="配送方式：">-->
<!--                            <span>{{list.buybox_ship}}</span>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="卖家数量：">-->
<!--                            <span>{{list.seller_num}}</span>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="变体数量：">-->
<!--                            <span>{{list.variant_num}}</span>-->
<!--                        </el-form-item>-->
                        <el-form-item label="上架日期：">
                            <span>{{list.listed_since}}</span>
                        </el-form-item>
<!--                        <el-form-item label="库存是否充足：">-->
<!--                            <span>{{inventory}}</span>-->
<!--                        </el-form-item>-->
                        <el-form-item label="备注：">
                            <span>{{list.remark}}</span>
                        </el-form-item>
                        <el-form-item label="更新时间：">
                            <span>{{list.keepa_update_time}}</span>
                        </el-form-item>
                        <!-- <el-form-item label="Amazon's Choice：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="变体个数：">
                            <span>80</span>
                        </el-form-item>
                        <el-form-item label="Q&A数：">
                            <span>19</span>
                        </el-form-item>
                        <el-form-item label="上架时间：">
                            <span>2019-07-02</span>
                        </el-form-item>
                        <el-form-item label="页面库存：">
                            <span>充足</span>
                        </el-form-item>
                        <el-form-item label="产品尺寸：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="卖家数量：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="入围榜单：">
                            <div class="ru_span">Best Sellers,Gift Ideas,Most Wished For</div>
                        </el-form-item>
                        <el-form-item label="Newer Model：">
                            <span>无</span>
                        </el-form-item> -->
                    </el-form>
                </div>
            </div>
        </el-card>
    </div>
    <!-- <div style="display: flex;">
        <el-card class="box-card" style="min-width: 400px;width: 32.75rem;">
            <el-carousel :interval="4000" type="card" height="250px">
                <el-carousel-item v-for="(item, index) in imaArr" :key="index">
                    <el-image
                        style="width: 100%;"
                        :src="item">
                    </el-image>
                </el-carousel-item>
            </el-carousel>
            <div style="width: 100%;">
                <h4 class="title_h4">Bullet points</h4>
                <div class="content_div">
                    <div style="position: relative; overflow: hidden; display: inline-block; margin: 0px; width: 100%; height: 170px;width: 100%!important;">
                        <div style="overflow: hidden; position: relative; display: block;width: 100%;height: 10.625rem;overflow: scroll;">
                            <ul style="width: 98%;font-size: 13px;">
                                <li class="ng-star-inserted">
                                    【Our Promise】All Personalized Necklace are Made in USA. We will ship within two days. Please feel free to contact us whenever you have any concern about our personalized necklace. Personalized items cannot be accepted for return.
                                </li>
                                <li class="ng-star-inserted">
                                    【Gift for】Customized Name Necklace Can Be a Lovely Gift for Your Mom, Daughter, Sister, Wife, Girlfriend, Loved One or a Special Treat for Yourself.
                                </li>
                                <li class="ng-star-inserted">
                                    【Perfect Gift】Personalized Name Necklace with Beautiful Handwriting is the Ideal Name Necklace Custom Gift for Valentine's Day, Birthday, Christmas, Mother's Day, Anniversary, Wedding, Graduation.
                                </li>
                                <li class="ng-star-inserted">
                                    【Chain Length】There are five different chain lengths can be chosen, 14", 16", 18",20" and 22". Name necklace makes a great everyday necklace and looks great layered with your other necklaces.
                                </li>
                                <li class="ng-star-inserted">
                                    【Material】 925 Sterling Silver Pendant Necklace with Free Gift Box. Necklace should stay dry with your name necklace personalized and keep away from sulfur, chlorine, chemicals and sweat.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card class="box-card" style="min-width: 700px;width: calc(100% - 34rem);margin-left: 1.25rem;">
            <div class="info-title">
                <div class="name" style="width: 100%">
                    <ul style="display: flex;">
                        <li>
                            <span>ASIN：</span>
                            <span style="font-weight: 400;">B07V2ZSSDX</span>
                            <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer;" title="复制"></i>
                        </li>
                        <li>
                            <span>PASIN：</span>
                            <span style="font-weight: 400;">B07TYJV497</span>
                            <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer;" title="复制"></i>
                        </li>
                        <li style="flex: 1;margin-right: 10px;text-align: right">
                            <i class="el-icon-download" style="margin-left: 5px;font-size: 18px;color: red;cursor: pointer;" title="下载"></i>
                            <i class="el-icon-paperclip" style="margin-left: 5px;font-size: 18px;color: red;cursor: pointer;" title="跳转链接"></i>
                        </li>
                    </ul>
                    <div class="des">
                        <span class="des-title">
                            <span>
                                标题：
                            </span>
                            CLY Jewelry Personalized Name Necklace Sterling Silver Pendant Customized Custom
                        </span>
                        <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer;" title="复制"></i>
                    </div>
                </div>
            </div>
            <div class="all-type">
                <div class="left-ul">
                    <el-form label-width="50%">
                        <el-form-item label="品牌：">
                            <span>CLY Jewelry</span>
                        </el-form-item>
                        <el-form-item label="评分数/评论数：">
                            <span>2,206 / 188</span>
                        </el-form-item>
                        <el-form-item label="好评率：">
                            <span>79%</span>
                        </el-form-item>
                        <el-form-item label="差评率：">
                            <span>12%</span>
                        </el-form-item>
                        <el-form-item label="评分/星级：">
                            <div style="display: flex;align-items: center;">
                                <span style="margin-right: 5px;">4.3</span>
                                <el-rate
                                    :value="4.3"
                                    disabled
                                    score-template="{value}"
                                ></el-rate>
                            </div>
                        </el-form-item>
                        <el-form-item label="BuyBox价格：">
                            <span>$14.99</span>
                        </el-form-item>
                        <el-form-item label="Buybox卖家：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="Buybox配送：">
                            <span>无</span>
                        </el-form-item>
                        <el-form-item label="Buybox卖家所属地：">
                            <span>--</span>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="width: 50%">
                    <el-form label-width="50%">
                        <el-form-item label="Amazon's Choice：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="变体个数：">
                            <span>80</span>
                        </el-form-item>
                        <el-form-item label="Q&A数：">
                            <span>19</span>
                        </el-form-item>
                        <el-form-item label="上架时间：">
                            <span>2019-07-02</span>
                        </el-form-item>
                        <el-form-item label="页面库存：">
                            <span>充足</span>
                        </el-form-item>
                        <el-form-item label="产品尺寸：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="卖家数量：">
                            <span>--</span>
                        </el-form-item>
                        <el-form-item label="入围榜单：">
                            <div class="ru_span">Best Sellers,Gift Ideas,Most Wished For</div>
                        </el-form-item>
                        <el-form-item label="Newer Model：">
                            <span>无</span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-card>
    </div> -->
</template>

<script>
// import * as api from "@/api/statistics/statistics";
import * as api from '@/api/Product/Product.js'
export default {
    data() {
        return {
            list: {}
        };
    },
    mounted() {
        this.getList();
    },
    computed: {
        is_dog() {
            return this.list.running_status == -1 ? "是" : "否";
        },
        inventory() {
            return this.list.inventory == 0 ? "否" : "是";
        },
        buybox_price() {
            return this.list.buybox_price ? this.list.buybox_price : "未读取";
        }
    },
    props: {
        id: {
            type: String,
            default: ""
        }
    },
    methods: {
        getList() {
            api.seed_word_asin_get_detail({
                id: this.$route.query.id
            })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        // this.list = res.data.detail_list;
                        // this.query.total = res.data.total;
                        this.list = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
            // let data = [
            //     "https://m.media-amazon.com/images/I/31Zjs1B-s7L._AC_UL780_.jpg",
            //     "https://m.media-amazon.com/images/I/41ix8u96ONS._AC_UL780_.jpg",
            //     "https://m.media-amazon.com/images/I/51ziQLWK1KS._AC_UL780_.jpg",
            //     "https://m.media-amazon.com/images/I/41QsCCrMbFS._AC_UL780_.jpg",
            //     "https://m.media-amazon.com/images/I/515dm-5HyYS._AC_UL780_.jpg",
            //     "https://m.media-amazon.com/images/I/41JCtwitPOS._AC_UL780_.jpg"
            // ];
            // this.imaArr = data;
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.grade_num {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.all-type {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
    .left-ul {
        width: 49%;
        border-right: 1px solid #ebebeb;
    }
    .ru_span {
        color: #515151;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 70%;
    }
}
.des-title {
    overflow: hidden;
    height: 0.9375rem;
    line-height: 0.875rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #3a3a3a;
}
.des {
    display: flex;
    align-items: flex-end;
    margin-top: 1.25rem;
    height: 0.875rem;
    line-height: 0.875rem;
    width: 93%;
}
.info-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    li {
        height: 0.875rem;
        line-height: 0.875rem;
        margin-right: 3.75rem;
        font-size: 0.875rem;
        color: #3a3a3a;
        font-weight: 700;
    }
}
.ng-star-inserted {
    margin-bottom: 5px;
    list-style: none;
    color: #303133;
}
.ng-star-inserted:before {
    font-size: 0.875rem;
    margin-right: 0.25rem;
    color: #030303;
    content: "●";
}
.title_h4 {
    font-size: 1rem;
    color: #030303;
    height: 1rem;
    line-height: 1rem;
    font-weight: 500;
    margin-top: 0.25rem;
    margin-bottom: 0 !important;
}
/deep/ .el-form-item {
    margin-bottom: 6px !important;
}
/deep/ .el-form-item__label {
    font-weight: 400 !important;
}
.content_div {
    margin-top: 1rem;
    box-sizing: border-box;
    /deep/ ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.3);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 5px;
        background-color: rgba(144, 147, 153, 0.35);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
</style>
